export enum StatusChangeFailureStatus {
    tagRequired = 1,
    categoryRequired = 2,
}
